import { Button } from "@/components/ui/button";
import { Linkedin, Facebook } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function LandingFooter() {
  const navigate = useNavigate();
  
  const footerLinks = {
    Product: ["Features", "Pricing"],
    Company: ["About", "Contact"],
  };

  const scrollToFeatures = () => {
    const featuresSection = document.getElementById('features');
    if (featuresSection) {
      featuresSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="border-t bg-muted/30">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-5 gap-12 mb-12">
          <div className="md:col-span-2">
            <div className="text-2xl font-bold mb-4">
              AMPA Network
            </div>
            <p className="text-sm text-muted-foreground mb-6 max-w-sm">
              The all-in-one sales platform that helps teams scale faster with CRM, analytics, AI automation, and leadership tools.
            </p>
            <div className="flex gap-3">
              <Button size="icon" variant="ghost">
                <Linkedin className="h-5 w-5" />
              </Button>
              <Button size="icon" variant="ghost">
                <svg className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                </svg>
              </Button>
              <Button size="icon" variant="ghost">
                <Facebook className="h-5 w-5" />
              </Button>
            </div>
          </div>
          {Object.entries(footerLinks).map(([category, links], categoryIndex) => (
            <div key={category}>
              <h3 className="font-semibold mb-4">
                {category}
              </h3>
              <ul className="space-y-3">
                {links.map((link, linkIndex) => (
                  <li key={link}>
                    <button 
                      onClick={link === "Features" ? scrollToFeatures : undefined}
                      className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                    >
                      {link}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="border-t pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-sm text-muted-foreground">
              © {new Date().getFullYear()} AMPA Network. All rights reserved.
            </div>
            <div className="flex gap-6 text-sm text-muted-foreground">
              <button 
                onClick={() => navigate("/privacy")}
                className="hover:text-foreground transition-colors"
              >
                Privacy Policy
              </button>
              <button 
                onClick={() => navigate("/privacy")}
                className="hover:text-foreground transition-colors"
              >
                Terms of Service
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
